import { render, staticRenderFns } from "./AwlModalCard.vue?vue&type=template&id=06716433&"
import script from "./AwlModalCard.vue?vue&type=script&lang=js&"
export * from "./AwlModalCard.vue?vue&type=script&lang=js&"
import style0 from "./AwlModalCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports